<script setup lang="ts">
import ConfirmCancelAIGeneration from "@/modules/writtenContent/components/dialogs/ConfirmCancelAIGeneration.vue";
import ProcessingAISnackbar from "@/modules/writtenContent/components/ProcessingAISnackbar.vue";
import { useWrittenContentStore } from "@/modules/writtenContent/store";
import ProcessingAITranslateSnackbar from "./ProcessingAITranslateSnackbar.vue";

const writtenContentStore = useWrittenContentStore();
</script>

<template>
  <div v-for="(item, index) in writtenContentStore.aiTasks" :key="index">
    <ProcessingAISnackbar
      v-if="item.taskType === 'generate'"
      :key="'pais' + item.writtenContentData.id"
      v-model:dialogVisible="item.visible"
      :position="index"
      :sklId="item.skl_id"
      :taskItem="item"
      :productRecommendationPath="item.recommendation_file_path"
      :writtenContentData="item.writtenContentData"
    />
    <ProcessingAITranslateSnackbar
      v-if="item.taskType === 'translate'"
      :key="'paits' + item.writtenContentTargetData.id"
      v-model:dialogVisible="item.visible"
      :taskItem="item"
      :position="index"
    />
    <ConfirmCancelAIGeneration
      v-if="item"
      :key="'ccaig' + item.writtenContentData.id"
      v-model:dialogVisible="item.cancelVisible"
      :currentWrittenContent="item.writtenContentData.id"
      @aiWrittenContentCancelProcess="item.cancelAction = true"
    />
  </div>
</template>
